import styled from "styled-components"

export const HomePageStyled = styled.div`
  font-family: Lato;

  @media only screen and (max-width: 767px) {
    margin-bottom: 92px;
  }
`
